import { render, staticRenderFns } from "./LoginWxCallBack.vue?vue&type=template&id=6edfec98&scoped=true"
import script from "./LoginWxCallBack.vue?vue&type=script&lang=js"
export * from "./LoginWxCallBack.vue?vue&type=script&lang=js"
import style0 from "./LoginWxCallBack.vue?vue&type=style&index=0&id=6edfec98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edfec98",
  null
  
)

export default component.exports